<div class="extras-container" [formGroup]="userForm">
  <h3><i class="bi bi-trophy"></i> Extras</h3>

  <div class="extras-section">
    <div class="section-header column">
      <span>
        <i class="bi bi-patch-check"></i>
        Certifications
      </span>
    </div>

    <div formArrayName="certificates">
      <div
        *ngFor="let cert of certificates.controls; let i = index"
        [formGroupName]="i"
        class="extras-card"
      >
        <button type="button" class="remove-btn" (click)="removeCertificate(i)">
          <i class="bi bi-trash"></i>
        </button>

        <div class="form-grid">
          <div class="form-group">
            <label>Name <span> *</span></label>
            <input
              formControlName="name"
              placeholder="e.g. AWS Certified Developer"
            />

          <small class="text-danger smaller-text"
            *ngIf="getControl(certificates, i, 'name')?.invalid 
            && (getControl(certificates, i, 'name')?.touched || getControl(certificates, i, 'name')?.dirty)">
            Certificate name is required
          </small>

          </div>

          <div class="form-group">
            <label>Platform / Issuer</label>
            <input
              formControlName="platform"
              placeholder="e.g. Coursera, Google"
            />
          </div>

          <div class="form-group">
            <label>Year</label>
            <input formControlName="year" placeholder="e.g. 2024"
                  maxlength="4"
                  (input)="onYearInput($event)" />

                  <div class="text-danger smaller-text" *ngIf="getControl(certificates, i, 'year')?.invalid &&
                  (getControl(certificates, i, 'year')?.touched || getControl(certificates, i, 'year')?.dirty)">
             
                <small *ngIf="getControl(certificates, i, 'year')?.errors?.['pattern']">Enter valid 4-digit year</small>
               <small *ngIf="getControl(certificates, i, 'year')?.errors?.['max']">Future year not allowed</small>
            </div>
          </div>
        </div>
      </div>
    </div>

        <div class="section-header column">
    <button type="button" (click)="addCertificate()" class="add-btn">
        <i class="bi bi-plus"></i> Add Certificate
      </button>
    </div>
  </div>

  <div class="extras-section">
    <div class="section-header column">
      <span>
        <i class="bi bi-award"></i>
        Awards & Achievements
      </span>
    </div>

    <div formArrayName="awards">
      <div
        *ngFor="let award of awards.controls; let i = index"
        [formGroupName]="i"
        class="extras-card"
      >
        <button type="button" class="remove-btn" (click)="removeAward(i)">
          <i class="bi bi-trash"></i>
        </button>

        <div class="form-grid">
          <div class="form-group">
            <label>Award Name <span> *</span> </label>
            <input
              formControlName="name"
              placeholder="e.g. Top Performer 2022"
            />

              <small class="text-danger smaller-text"
                *ngIf="getControl(awards, i, 'name')?.invalid 
                && (getControl(awards, i, 'name')?.touched || getControl(awards, i, 'name')?.dirty)">
                Award name is required
              </small>

          </div>

          <div class="form-group">
            <label>Organization</label>
            <input
              formControlName="org"
              placeholder="e.g. College / Company"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="section-header column">
      <button type="button" (click)="addAward()" class="add-btn">
        <i class="bi bi-plus"></i> Add Award
      </button>
    </div>
  </div>

  <div class="extras-section">
    <div class="section-header column">
      <span>
        <i class="bi bi-code-slash"></i>
        Hackathons
      </span>
    </div>

    <div formArrayName="hackathons">
      <div
        *ngFor="let hack of hackathons.controls; let i = index"
        [formGroupName]="i"
        class="extras-card"
      >
        <button type="button" class="remove-btn" (click)="removeHackathon(i)">
          <i class="bi bi-trash"></i>
        </button>

        <div class="form-grid">
          <div class="form-group">
            <label>Hackathon Name <span> *</span> </label>
            <input
              formControlName="name"
              placeholder="e.g. Smart India Hackathon"
            />

           <small class="text-danger smaller-text"
            *ngIf="getControl(hackathons, i, 'name')?.invalid 
            && (getControl(hackathons, i, 'name')?.touched || getControl(hackathons, i, 'name')?.dirty)">
            Hackathon name is required
          </small>

          </div>

          <div class="form-group">
            <label>Rank / Achievement</label>
            <input
              formControlName="rank"
              placeholder="e.g. 1st / Finalist"
            />
          </div>
        </div>
      </div>
    </div>

        <div class="section-header column">
     <button type="button" (click)="addHackathon()" class="add-btn">
        <i class="bi bi-plus"></i> Add Hackathon
      </button>
    </div>
  </div>

  <div class="extras-section">
    <div class="section-header column">
      <span>
        <i class="bi bi-translate"></i>
        Languages
      </span>
    </div>

    <div formArrayName="languages">
      <div
        *ngFor="let lang of languages.controls; let i = index"
        [formGroupName]="i"
        class="extras-card"
      >
        <button type="button" class="remove-btn" (click)="removeLanguage(i)">
          <i class="bi bi-trash"></i>
        </button>

        <div class="form-grid grid-2">
          <div class="form-group">
            <label>Language <span> *</span> </label>
            <select formControlName="name">
              <option value="" disabled>Select Language</option>
              <option *ngFor="let lang of languageOptions" [value]="lang"> {{ lang }}</option>
            </select>

          <small class="text-danger smaller-text"
            *ngIf="getControl(languages, i, 'name')?.invalid 
            && (getControl(languages, i, 'name')?.touched || getControl(languages, i, 'name')?.dirty)">
            Language is required
          </small>

          </div>

          <div class="form-group">
            <label>Proficiency</label>
            <select formControlName="level">
              <option value="" disabled>Select Level</option>
              <option>Beginner</option>
              <option>Intermediate</option>
              <option>Professional</option>
              <option>Native</option>
            </select>
          </div>
        </div>
      </div>
    </div>

        <div class="section-header column">
    <button type="button" (click)="addLanguage()" class="add-btn">
        <i class="bi bi-plus"></i> Add Language
      </button>
</div>
  </div>
</div>
